import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import localforage from 'localforage';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  tempFilter2DurationState
} from '#state';

export function TempFilter2Duration() {
  const [duration, setDuration] =
    useRecoilState(tempFilter2DurationState);

  useEffect(() => {
    localforage.setItem('tempFilter2DurationState', duration);
  }, [duration]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    const v = parseFloat(newValue)
    if (v >= 1) {
      setDuration(v);
    } else {
      setDuration(6);
    }
  };

  return (
    <TextField
      size='small'
      sx={{ width: '4rem' }}
      label="T F1 Hours"
      type="number"
      inputProps={{ min: 1 }} // set the minimum value to 1
      value={duration}
      onChange={handleChange}
    />
  );
}

export default TempFilter2Duration;